import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ProductModuleState } from '../../models/product.model';
import { adapter } from '../reducers/product.reducer';

const { selectAll } = adapter.getSelectors();
export const getProductModuleState = createFeatureSelector<ProductModuleState>('productModule');
export const getProductsState = createSelector(getProductModuleState, (state) => state.products);
export const getProducts = createSelector(getProductsState, selectAll);
export const getSelectedProduct = createSelector(
  getProductModuleState,
  (state) => state.selectedProduct,
);
export const getSelectedCountry = createSelector(
  getProductModuleState,
  (state) => state.selectedCountry,
);
